import type { TotalsBlock } from "@platform/api";

/** Label shown for the default totals block when the analyst hasn't renamed it. */
const DEFAULT_TOTALS_BLOCK_NAME = "Totals";

/**
 * Display name for a totals block — its analyst-chosen name, custom or
 * default. Falls back to the default label when the block is missing
 * entirely (e.g. a context lookup by a stale block id).
 */
export const resolveTotalsBlockName = (block?: TotalsBlock): string => {
  const name = block?.name?.trim();
  return name ? name : DEFAULT_TOTALS_BLOCK_NAME;
};
